module.exports = __webpack_public_path__ + "img/logop2.50e62cbc.png";